import { InjectionToken } from '@angular/core'

export const PRESET_PAGES_MAP = new InjectionToken('Preset page map')
